import React, { useState } from 'react';
import Typography from '@mui/material/Typography';
import InputField from '../../../../../FormControl/input/InputField';
import DialogConfirm from '../../../../../dialog/DialogConfirm';
import usePeriodicalReportSetting from '../../../../../../hooks/periodical-report/usePeriodicalReportSetting';
import { Alert, Divider } from '@mui/material';
import SelectCurriculum from '../../SelectCustom/SelectCurriculum';

const TypeDialog = ({ show, onClose, type, formData = {}, onReset }) => {
  const types = ['create', 'edit', 'delete', 'preview'];
  const { createSubModule, updateSubModule, deleteSubModule } = usePeriodicalReportSetting();
  const [form, setInputForm] = useState(formData);
  const [errors, setInputErrors] = useState(null);
  const [loading, toggleLoading] = useState(false);

  const onChange = (name, value) => {
    setInputForm({ ...form, [name]: value });
    setInputErrors({ ...errors, [name]: null });
  };

  const onSave = async (e) => {
    if (!types.includes(type)) {
      setInputErrors({ message: 'Invalid type' });
      return;
    }
    e.preventDefault();
    toggleLoading(true);
    try {
      let result = { error: false };
      if (type === 'create') {
        result = await createSubModule(form, 'type');
      }
      if (type === 'edit') {
        result = await updateSubModule(form._id, 'type', form);
      }
      if (type === 'delete') {
        result = await deleteSubModule(form._id, 'type');
      }
      if (result.error) {
        setInputErrors(result);
      } else {
        onClose();
        onReset();
      }
    } finally {
      toggleLoading(false);
    }
  };

  return (
    <DialogConfirm
      id={`${type}-type`}
      open={show}
      title={`${type} type`}
      onCancel={onClose}
      onConfirm={['create', 'edit', 'delete'].includes(type) ? onSave : undefined}
      textConfirm={type === 'delete' ? 'Confirm' : 'Save'}
      onCloseHeader={type === 'preview'}
      showActions={['create', 'edit', 'delete'].includes(type)}
      loading={loading}
      maxWidth='xs'
    >
      {types.includes(type) ? (
        <>
          {type === 'delete' ? (
            <Typography component={'div'}>
              Are you sure you want to delete the type: <b>{form.name}</b>?
            </Typography>
          ) : (
            <div className='flex flex-col gap-4 py-4'>
              <div className='grid grid-cols-4 items-center gap-4'>
                <Typography variant='inherit' className='font-bold' color='primary' align='right' component='p'>
                  Curriculum
                </Typography>
                <div className='col-span-3'>
                  <SelectCurriculum
                    id="curriculum-level"
                    name="curriculumId"
                    value={form?.curriculumId}
                    onChange={(e) => onChange("curriculumId", e.target.value)}
                    error={errors?.curriculumId}
                    isPreview={type === 'preview'}
                  />
                </div>
                <Divider className='col-span-full' />
                <Typography
                  variant='inherit'
                  className='font-bold'
                  color='primary'
                  align='right'
                  component='p'
                >
                  Code
                </Typography>
                <div className='col-span-3'>
                  {['preview', 'edit'].includes(type) ? (
                    <Typography>{form.code}</Typography>
                  ) : (
                    <InputField
                      id='code'
                      name='code'
                      value={form.code}
                      error={errors?.code}
                      helperText={errors?.code}
                      onChange={(e) => onChange('code', e.target.value)}
                      fullWidth
                    />
                  )}
                </div>
                <Typography
                  variant='inherit'
                  className='font-bold'
                  color='primary'
                  align='right'
                  component='p'
                >
                  Name
                </Typography>
                <div className='col-span-3'>
                  {type === 'preview' ? (
                    <Typography>{form.name}</Typography>
                  ) : (
                    <InputField
                      id='name'
                      name='name'
                      value={form.name}
                      error={errors?.name}
                      helperText={errors?.name}
                      onChange={(e) => onChange('name', e.target.value)}
                      fullWidth
                    />
                  )}
                </div>
                <Typography
                  variant='inherit'
                  className='font-bold'
                  color='primary'
                  align='right'
                  component='p'
                >
                  Description
                </Typography>
                <div className='col-span-3'>
                  {type === 'preview' ? (
                    <Typography>{form.description}</Typography>
                  ) : (
                    <InputField
                      id='description'
                      name='description'
                      value={form.description}
                      error={errors?.description}
                      helperText={errors?.description}
                      onChange={(e) => onChange('description', e.target.value)}
                      fullWidth
                      multiline={true}
                    />
                  )}
                </div>
              </div>
            </div>
          )}
        </>
      ) : (
        <Alert severity='error'>Invalid type</Alert>
      )}
      {errors && errors.message && (
        <Alert severity='error' onClose={() => setInputErrors({ message: null })}>
          {errors.message}
        </Alert>
      )}
    </DialogConfirm>
  );
};

export default TypeDialog;
